// test minibus
function municipal(state = {
  isFetching: true,
  results: [],
  next: null
}, action) {
  switch(action.type) {
    case 'MUNICIPAL_FETCHED':
      const results = [
        ...state,
        ...action
      ]
      return Object.assign({}, state, {
        isFetching: false,
        results: action,
      })
    case 'REFRESH_FETCH':
      return Object.assign({}, state, {
        isFetching: false,
        results: action,
      })
    default:
      return state;
  }
}

export default municipal;




// WEBPACK FOOTER //
// ./src/reducers/municipal.js